import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}
// 编辑
export function detail(data) {
  return request({
    url: '/openAccount',
    method: 'get',
    params: data,
  });
}
// 根据已有编号 id 查询电表
export function selectOne(data) {
  return request({
    url: '/meter/selectOne',
    method: 'get',
    params: data,
  });
}

export function meterDetail(data) {
  return request({
    url: '/meter',
    method: 'get',
    params: data,
  });
}
// 新增电表
export function addMeter(data) {
  return request({
    url: '/meter',
    method: 'post',
    data: data,
  });
}

// 开户保存修改
export function editSave(data) {
  return request({
    url: '/openAccount/edit',
    method: 'post',
    data: data,
  });
}

// 根据已有编号 id 查询水表
export function selectOneWater(data) {
  return request({
    url: '/waterMeter/selectOne',
    method: 'get',
    params: data,
  });
}
// 新增水表
export function addWaterMeter(data) {
  return request({
    url: '/waterMeter',
    method: 'post',
    data: data,
  });
}

// 查看水表详情
export function detailWater(data) {
  return request({
    url: '/waterMeter',
    method: 'get',
    params: data,
  });
}
// 查找某个配置项
export function systemCustomConfig(data) {
	return request({
		url: '/systemCustomConfig/selectDicValueByDicKey',
		method: 'get',
		params: data,
	});
}